<template>
<div class="footer">    
  <div class="content-wrapper review-container">
      <div class="content-width">
        <div>
          <h1 class="color-primary-dark">Wat onze klanten vinden</h1>
          <p class="quote">Wij doen al diverse jaren heel prettig zaken met Rojeca.
Ze staan 24/7 voor ons klaar en leveren een zeer professionele en persoonlijke service.
Iedere vraag, hoe vreemd die mag zijn, wordt altijd serieus behandeld.
Mede door het advies van Rojeca kunnen wij onze klanten en chauffeurs altijd de juiste keuzes laten maken.
          </p>
        <div class="logo-customer">
          <a href="https://europeanroadcargo.com/" target="_blank"><img src="../assets/erc_logo.png" alt=""></a>
        </div>
        </div>
      </div>
  </div>
    <div class="content-wrapper callout-container">
      <div class="content-width">

        <div class="certificates-container">
          <div class="certificate-item">
            <img src="../assets/vca_keurmerk.png"/>
            <p>
              Met het <a href="https://www.vca.nl/diplomas-certificaten/vol-vca" target="_blank">VOL-VCA</a> diploma weten we aan welke eisen u en de medewerkers waaraan u leiding geeft moeten voldoen.
            </p>
          </div>
          <div class="certificate-item">
            <img src="../assets/evo.png"/>
            <p>
              Rojeca is aangesloten bij de <a href="https://www.evofenedex.nl/" target="_blank">EVO</a>. Hiermee hebben we beschikking over 75 jaar logistieke kennis.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="info-container">
      <div class="content-width">
        <img class="logo" src="../assets/logo_rojeca_white.svg"/>
        <div class="footer-info">
          <h1 class="color-white">Info</h1>
          <ul>
            <li><div class="name">E-mail</div>{{ information.email}}</li>
            <li><div class="name">Telefoon</div>{{ information.telephoneNumber }}</li>
            <li><div class="name">KvK</div>{{ information.kvk }}</li>
            <li><div class="name">Adres</div>{{ information.street }}, {{ information.city }}</li>
          </ul>
        </div>
        <div class="footer-site">
          <h1 class="color-white">Site</h1>
          <ul>
            <li v-for="(item, i) in menuItems" :key="i">
                <router-link :to="item.url">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
        
      </div>
    </div>
    
</div>
</template>

<script>
import information from '../configurables/information.js'

export default {
  name: 'Footer',
  props: {
    menuItems: Array,
  },
  data () {
    return {
      information,
    }
  }
}
</script>

<style>


  .review-container {
    background: #eef8ff;
  }


  .review-container p.quote::after {
    background: #eef8ff;
  }

  .review-container img {
    width: 240px;
    filter: brightness(0.4);
  }

  .review-container .logo-customer {
    display: flex;
    justify-content: flex-end;
  }

  .callout-container {
    background: #eee;
  }

  .callout-container .content-width {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .callout-container .review-container {
    margin-bottom: var(--item-margin-large);
  }

  .callout-container .certificates-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .callout-container .certificates-container .certificate-item {
    display: flex;
    align-items: center;
  }
  .callout-container .certificates-container .certificate-item img {
    display: flex;
    flex-shrink: 0;
    width: 140px;
    height: 84px;
    margin-right: var(--item-margin);
    object-fit: contain;
  }

  .info-container {
    background: var(--primary-color-dark);
    color: white;
    display: flex;
    justify-content: center;
  }

  .info-container .content-width {
    padding: var(--item-padding-large) 0;
    display: flex;
    justify-content: space-between;
  }
  .info-container .content-width ul {
    padding: 0;
  }
  .info-container .content-width li {
    display: flex;
    list-style: none;
  }

  .info-container .content-width li .name {
    color: #ddd;
    width: 78px;
  }

  .info-container .logo {
    height: 50px;
    object-fit: contain;
  }

  .info-container .footer-site li a {
    color: white;
    text-decoration: none;
  }

  .info-container .footer-site li a.router-link-exact-active {
    display: none;
  }


  @media only screen and (max-width: 600px) {
    .info-container .logo {
      margin-bottom: var(--item-margin-large);
    }


    .callout-container .certificates-container {
      flex-direction: column;
    }

    .info-container .content-width {
      flex-direction: column;
      text-align: center;
      align-items: center;
    }

    .footer-info {
      margin-bottom: var(--item-margin);
    }

    .footer-site li{
      justify-content: center;
    }

    

  }

</style>


// WEBPACK FOOTER //
// src/components/footer.vue